<template>
  <div class="compare-container">
    <div class="header">
      <div class="column-item header-item" v-for="(item, index) in headers" :key="index">{{ item }}</div>
    </div>
    <div class="compare-content">
      <div class="change-item" ref="changeItems" v-for="(item, index_item) in compareList" :key="index_item">
        <div class="round">{{ item.name }}</div>
        <div class="term">
          <div class="term-li" v-for="(term, index_term) in item.changeList" :key="index_term">
            <div class="term-item">{{ term.changeType }}</div>
            <div class="term-item">{{ term.before }}</div>
            <div class="term-item">{{ term.after }}</div>
          </div>
        </div>
        <a-checkbox class="action" :defaultChecked="true" @change="changeCheckList(item)"></a-checkbox>
      </div>
    </div>
  </div>
</template>
<script>
import { queryChange } from '@/api/finance';
import moment from 'moment';
export default {
  watch: {
    refresh: {
      handler: function(oldVal, newVal) {
        this.getCompareData();
      },
      immediate: true
    }
  },
  props: {
    compareInfo: {
      type: Object
    },
    refresh: {
      type: Number
    },
    type: {
      type: String
    },
    fundInfoFlag: {
      type: Number
    }
  },
  data() {
    return {
      headers: ['项目', '变更项', '变更前', '变更后', '选择'],
      compareList: [],
      typeList: [],
      emptyEndFlag: false
    };
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    getCompareData() {
      // if (typeof this.compareInfo.thisEndDate === 'string') {
      //   this.compareInfo.thisEndDate = moment(this.compareInfo.thisEndDate);
      // }
      try {
        this.emptyEndFlag = false;
        queryChange({
          // type: this.type,
          versionId: this.compareInfo.itemId //fundId or fairId
          // endDate: this.compareInfo.thisEndDate.unix()
        }).then(res => {
          this.compareList = res.data.map(round => {
            round.checked = true;
            return round;
          });
          if (this.compareList.length === 0) {
            this.emptyEndFlag = true;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    changeCheckList(term) {
      term.checked = !term.checked;
      let ids = this.compareList.filter(item => item.checked).map(item => item.id);
      this.$emit('submitCheckIds', ids);
    },
    handleCompareListEnd() {
      this.$emit('switchRefreshFlag', false);
    }
  },
  updated() {
    // 在 updated() 钩子函数中判断 compareList 数组是否遍历结束
    if ((this.compareList.length > 0 && this.compareList.length === this.$refs.changeItems.length) || this.emptyEndFlag) {
      this.handleCompareListEnd();
    }
  }
};
</script>

<style lang="less">
.compare-container {
  border: 1px solid rgba(220, 220, 220, 1);
  padding: 10px 0;
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 450px;
  .column-item {
    text-align: center;
    &:nth-child(1) {
      flex: 0 0 10%;
    }
    &:nth-child(2) {
      flex: 0 0 28%;
    }
    &:nth-child(3) {
      flex: 0 0 28%;
    }
    &:nth-child(4) {
      flex: 0 0 28%;
    }
    &:nth-child(5) {
      flex: 0 0 6%;
    }
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .header-item {
      font-weight: bold;
    }
  }
  .change-hint {
    margin-top: 10px;
    background: rgba(225, 240, 212);
    color: #1890ff;
    height: 40px;
    line-height: 40px;
  }
  .change-item {
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgb(220, 220, 220);
    padding: 8px 0;
    &:last-child {
      border-bottom: 0;
    }
    .round {
      flex: 0 0 10%;
      width: 10%;
      text-align: center;
    }
    .action {
      flex: 0 0 6%;
      width: 6%;
      text-align: center;
    }
    .term {
      flex: 0 0 84%;
      width: 84%;
      .term-li {
        // margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2px 0;
        .term-item {
          text-align: center;
          &:nth-child(1) {
            flex: 0 0 33.3%;
            width: 33.3%;
          }
          &:nth-child(2) {
            flex: 0 0 33.3%;
            width: 33.3;
          }
          &:nth-child(3) {
            color: red;
            flex: 0 0 33.3%;
            width: 33.3%;
          }
        }
        transition: all 0.3s linear;
        background-color: white;
      }
      // .term-li:hover {
      //   background-color: #eee;
      // }
    }
  }

  @media screen and (max-width: 1440px) {
    .round,
    .term-item,
    .header-item {
      font-size: 13px;
    }
  }

  @media screen and (min-width: 1441px) {
    .round,
    .term-item,
    .header-item {
      font-size: 14px;
    }
  }
}
</style>
